import { AlertTriangle } from "lucide-react";

/**
 * The execute route's safety gate, rendered read-only.
 *
 * There is no approval gate any more — the backend removed `POST /api/plans/approve` and `/execute`
 * validates the stored execution contract at run time instead. A 409 from that validation is still a
 * real thing to surface, but it is information, not a decision: the server's own message says what is
 * wrong with the plan, and the fix is to re-plan in chat. So this replaces the old
 * RunBlockedBanner/ApproveErrorBanner pair, which offered Approve buttons that now have no endpoint
 * behind them.
 *
 * Amber rather than red on purpose: the run was refused, nothing failed.
 */
export function RunBlockedNote({ reason }: { reason: string }) {
	return (
		<p
			role="status"
			className="flex flex-wrap items-start gap-2 rounded-md border border-warning/40 bg-warning/10 p-2 text-xs leading-relaxed text-warning-strong"
		>
			<AlertTriangle className="mt-0.5 h-3.5 w-3.5 shrink-0" />
			<span className="min-w-0 flex-1 break-words">
				<span className="font-semibold">This plan can't run yet: </span>
				{reason}
			</span>
		</p>
	);
}
